const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ============================================================
   MILEAGE RUN CUSTOM
   Open outbound Little Wings links in a new tab so visitors
   don't leave the store. Uses rel="noopener" only, NOT
   "noreferrer", so Little Wings still sees mileagerungame.com
   as the referring site in their analytics on top of the UTMs.
   Added by Claude. Safe to edit or delete this block.
   ============================================================ */
(function () {
  function openLittleWingsInNewTab() {
    document.querySelectorAll('a[href*="littlewings.org.au"]').forEach(function (link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openLittleWingsInNewTab);
  } else {
    openLittleWingsInNewTab();
  }

  // Re-apply when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', openLittleWingsInNewTab);
})();
